import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectFilterData } from '../../features/mainFilter/selectors';

export const useGetWhatByCapacity = (who) => {
  const what = useSelector((state) => selectFilterData(state).searchEngine.what);

  return useMemo(() => {
    if (who.adults === 1 && who.children === 0) {
      return what.filter((item) => item.capacity?.includes('solo') || item.active);
    }

    if (who.childAges && who.childAges.length > 0) {
      return what.filter((item) => item.capacity?.includes('families') || item.active);
    }

    return what;
  }, [what, who]);
};
